import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'flx-snack',
  template: `
    <div
      class="pl-snack"
      [ngStyle]="{ background: background, color: color }"
      [ngClass]="customClass"
    >
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./snack.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SnackComponent {
  @Input() background;
  @Input() color;
  @Input() customClass;
}
